'use client';


/** Imports */
import React, {useContext} from 'react';
import styles from './style.module.css';
import {useTranslations} from 'next-intl';
import Switch from '@mui/material/Switch';
import {styled} from '@mui/material/styles';
import {FormControlLabel} from '@mui/material';
import {ThemeContext} from '@/context/ThemeContext';


/** Component */
export default function ThemeSwitcher() {

    // Hooks
    const {theme, setTheme} = useContext(ThemeContext);
    const t = useTranslations('common.Navigation.SwitchTheme');

    // Event handlers
    function toggle(event: React.ChangeEvent<HTMLInputElement>, checked: boolean) {
        event.stopPropagation();
        setTheme((checked) ? 'dark' : 'light');
    }


    // Render
    return (
        <div className={styles.themeSwitcher}>
            <FormControlLabel
                control={
                    <MaterialUISwitch
                        sx={{m: 1}}
                        checked={(theme === 'dark')}
                        onChange={toggle}
                    />
                }
                label={t('label')}
            />
        </div>
    );
}


/** Helper components */
const MaterialUISwitch = styled(Switch)(() => ({
    width: 62,
    height: 34,
    padding: 7,
    '& .MuiSwitch-switchBase': {
        margin: 1,
        padding: 0,
        transform: 'translateX(6px)',
        '&.Mui-checked': {
            color: '#fff',
            transform: 'translateX(22px)',
            '& .MuiSwitch-thumb:before': {
                backgroundImage: 'url(/images/theme/dark.svg)',
            },
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: 'rgb(var(--color-primary-light) / .5)',
            },
        },
    },
    '& .MuiSwitch-thumb': {
        backgroundColor: 'rgb(var(--color-primary-light))',
        width: 32,
        height: 32,
        '&::before': {
            content: '""',
            position: 'absolute',
            width: '100%',
            height: '100%',
            left: 0,
            top: 0,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundImage: 'url(/images/theme/light.svg)',
        },
    },
    '& .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: 'rgb(var(--color-primary-light) / .5)',
        borderRadius: 20 / 2,
    },
}));
